import http from './http';

export function getOverView() {
  return http.get('home/getHomeStatics');
}

export function getBarCharData() {
  return http.get('home/getBarCharData');
}
